import ConfirmationTypeIcon from './ui/ConfirmationTypeIcon.vue';
import ConfirmationTypeInfo from './ui/ConfirmationTypeInfo.vue';
import { ConfirmationType } from './lib/types';
import getConfirmationTypeName from './lib/getConfirmationTypeName';
import getConfirmationTypeAdditionals from './lib/getConfirmationTypeAdditionals';

export {
    ConfirmationTypeInfo,
    ConfirmationTypeIcon,
    ConfirmationType,
    getConfirmationTypeName,
    getConfirmationTypeAdditionals,
}